import { render, staticRenderFns } from "./TeamDetailsCardV2.vue?vue&type=template&id=aa86715e&scoped=true&"
import script from "./TeamDetailsCardV2.vue?vue&type=script&lang=ts&"
export * from "./TeamDetailsCardV2.vue?vue&type=script&lang=ts&"
import style0 from "./TeamDetailsCardV2.vue?vue&type=style&index=0&id=aa86715e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa86715e",
  null
  
)

export default component.exports